import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Select,
  SelectProps,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconAdjustmentsCog,
  IconCalendar,
  IconCheck,
  IconFlame,
  IconListCheck,
  IconSearch,
  IconStatusChange,
  IconUserShield,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblWarrantyInformation } from "../../../model/WarratyInformation";
import { getTblDmProcessingMethodSelect } from "../../../service/getSelectApi";
import "../../../Styles/tab.component.css";
import RemoteProcessing from "../RequestProcessing/RemoteProcessing";
import { useLocation } from "react-router-dom";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const WarrantyInformation = () => {
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblWarrantyInformation[]>([]);
  const [dataTemp, setDataTemp] = useState<TblWarrantyInformation[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination] = useState(paginationBase);
  const userLogin = JSON.parse(localStorage.getItem("userLogin") ?? "");
  const [dataProcessingMethodSelect, setDataProcessingMethodSelect] = useState<
    ComboboxItem[]
  >([]);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //search
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    processingMethod:
      _searchJson && checkedPinSearch ? _searchJson?.processingMethod : "",
    role: _searchJson && checkedPinSearch ? _searchJson?.role : "",
    priority: _searchJson && checkedPinSearch ? _searchJson?.priority : "",
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: `${userLogin.fullName}`,
        Header: () => (
          <Badge
            size="md"
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            {userLogin.fullName} - {userLogin.depName}
          </Badge>
        ),
        columns: [
          {
            accessorKey: "requestFormCode",
            header: "Số phiếu yêu cầu",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            Cell: ({ renderedCellValue, cell }) => (
              <Badge
                radius="sm"
                variant="dot"
                size="lg"
                color={renderedCellValue === null ? "red" : green.base}
              >
                {renderedCellValue === null ? null : renderedCellValue}
              </Badge>
            ),
            size: 200,
          },
          {
            accessorKey: "role",
            header: "Vai trò",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            filterFn: "equals",
            mantineFilterSelectProps: {
              data: [
                {
                  label: "Người nhận phân công",
                  value: "Người nhận phân công",
                },
                { label: "Người hỗ trợ", value: "Người hỗ trợ" },
                { label: "Người bổ sung", value: "Người bổ sung" },
              ],
            },
            filterVariant: "select",
            Cell: ({ row }) => (
              <Badge color={getColorRole(row.original.role)} radius={"sm"}>
                {row.original.role}
              </Badge>
            ),
            size: 225,
          },
          {
            accessorKey: "processingMethodName",
            header: "Hình thức xử lý",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            Cell: ({ row }) => (
              <Badge
                color={getColorProcessingMethod(
                  row.original.processingMethodName,
                )}
                radius={"sm"}
              >
                {row.original.processingMethodName}
              </Badge>
            ),
            filterFn: "equals",
            mantineFilterSelectProps: {
              data: [
                { label: "Xử lý tại nhà", value: "Xử lý tại nhà" },
                { label: "Xử lý tại CH/CN", value: "Xử lý tại CH/CN" },
                { label: "Hãng xử lý", value: "Hãng xử lý" },
                { label: "Xử lý trực tiếp", value: "Xử lý trực tiếp" },
                { label: "Xử lý từ xa", value: "Xử lý từ xa" },
              ],
            },
            filterVariant: "select",
          },
          {
            accessorKey: "assignedDate",
            header: "Ngày phân công",
            enableColumnActions: true,
            enableSorting: false,
            Cell: ({ renderedCellValue }: any) => (
              <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
            ),
            enableColumnFilter: false,
          },
          {
            accessorKey: "requestStatusName",
            header: "Trạng thái",
            enableColumnActions: true,
            enableSorting: false,
            Cell: ({ row }) => (
              <Badge
                radius={"sm"}
                color={getColorStatus(
                  row.original.requestStatusName?.toString(),
                )}
                variant="light"
                bd={`1px solid ${getColorStatus(
                  row.original.requestStatusName?.toString(),
                )}`}
              >
                {row.original.requestStatusName}
              </Badge>
            ),
            enableColumnFilter: false,
          },
          {
            accessorKey: "priority",
            header: "Mức độ ưu tiên",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            filterFn: "equals",
            mantineFilterSelectProps: {
              data: [
                { label: "Cao", value: "Cao" },
                { label: "Thấp", value: "Thấp" },
              ],
            },
            filterVariant: "select",
            Cell: ({ row }) => (
              <Badge
                color={getColorPriority(row.original.priority)}
                radius={"sm"}
              >
                {row.original.priority}
              </Badge>
            ),
          },
          {
            accessorKey: "customerName",
            header: "Khách hàng",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            Cell: ({ renderedCellValue, row }) => (
              <AvatarUtils value={renderedCellValue?.toString() ?? " "} />
            ),
            size: 225,
          },
          {
            accessorKey: "customerPhoneNumber",
            header: "SĐT",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
          },
          {
            accessorKey: "customerAddress",
            header: "Địa chỉ",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
            size: 550,
          },
          {
            accessorKey: "content",
            header: "Nội dung",
            enableColumnActions: true,
            enableSorting: false,
            enableColumnFilter: false,
          },
          {
            accessorKey: "action",
            header: "Thao tác",
            enableColumnActions: true,
            enableColumnFilter: false,
            enableSorting: false,
            enableResizing: false,
            Cell: ({ row }) => (
              <Flex align={"center"} gap={10}>
                <Tooltip label="Cập nhật bảo hành">
                  <ActionIcon
                    variant="light"
                    color="teal"
                    onClick={() =>
                      modalRemoteProcessing(
                        Number(row.original.requestFormId),
                        row.original.requestStatusName,
                        row.original.processingMethod,
                      )
                    }
                    disabled={row.original.requestStatusName === "Đã xử lý"}
                  >
                    <IconListCheck size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Flex>
            ),
            size: 85,
          },
        ],
      },
    ],
    [],
  );

  function getColorStatus(status: string) {
    switch (status) {
      case "Đã phân công":
      case "Đã xử lý":
      case "Hãng đã xử lý":
      case "Trả khách":
        return "#4CAF50";

      case "Chờ phân công":
      case "Xử lý lại":
      case "Hãng đang xử lý":
      case "Chưa xử lý":
        return "#d9d02f";

      case "Hủy phân công":
      case "Kỹ thuật hủy":
        return "#F44336";

      case "Hãng xử lý":
        return "#2196F3";

      case "Đang xử lý":
      case "Hãng đang xử lý":
        return "#FF9800";

      case "":
      case null:
        return "rgba(255, 255, 255, 0)";

      default:
        return "#424242";
    }
  }

  function getColorRole(value: string | null) {
    switch (value) {
      case "Người nhận phân công":
        return "#16423C";
      case "Người hỗ trợ":
        return "#6A9C89";
      case "Người bổ sung":
        return "#C4DAD2";
    }
  }

  function getColorPriority(value: string | null) {
    switch (value) {
      case "Cao":
        return "#FF0000";
      case "Thấp":
        return "#808080";
      case null:
        return "rgba(255, 255, 255, 0)";
    }
  }

  function getColorProcessingMethod(value: string | null) {
    switch (value) {
      case "Xử lý tại nhà":
        return "lime";
      case "Hãng xử lý":
        return "green";
      case "Xử lý trực tiếp":
        return "teal";
      case "Xử lý tại CH/CN":
        return "cyan";
      case "Xử lý từ xa":
        return "orange";
      case "":
      case null:
        return "rgba(255, 255, 255, 0)";
    }
  }

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData: any) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData: any) => ({ ...prevData, [key]: "" }));
    }
  };

  const optionColorsStatus: Record<
    | "Chờ phân công"
    | "Hủy phân công"
    | "Đã phân công"
    | "Hãng đang xử lý"
    | "Kỹ thuật hủy"
    | "Đã xử lý"
    | "Xử lý lại"
    | "Hãng xử lý"
    | "Đang xử lý"
    | "Trả khách",
    string
  > = {
    "Chờ phân công": "#d9d02f",
    "Hủy phân công": "#F44336",
    "Đã phân công": "#4CAF50",
    "Hãng đang xử lý": "#FF9800",
    "Kỹ thuật hủy": "#F44336",
    "Đã xử lý": "#4CAF50",
    "Xử lý lại": "#d9d02f",
    "Hãng xử lý": "#2196F3",
    "Đang xử lý": "#FF9800",
    "Trả khách": "#4CAF50",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsStatus[
            option.label as
              | "Chờ phân công"
              | "Hủy phân công"
              | "Đã phân công"
              | "Hãng đang xử lý"
              | "Kỹ thuật hủy"
              | "Đã xử lý"
              | "Xử lý lại"
          ]
        }
        radius="sm"
        variant="light"
        bd={`1px solid ${
          optionColorsStatus[
            option.label as
              | "Chờ phân công"
              | "Hủy phân công"
              | "Đã phân công"
              | "Hãng đang xử lý"
              | "Kỹ thuật hủy"
              | "Đã xử lý"
              | "Xử lý lại"
          ]
        }`}
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorProcessingMethod: Record<
    | "Xử lý tại nhà"
    | "Xử lý tại CH/CN"
    | "Hãng xử lý"
    | "Xử lý trực tiếp"
    | "Xử lý từ xa",
    string
  > = {
    "Xử lý tại nhà": "lime",
    "Xử lý tại CH/CN": "cyan",
    "Hãng xử lý": "green",
    "Xử lý trực tiếp": "teal",
    "Xử lý từ xa": "orange",
  };

  const optionColorRole: Record<
    "Người nhận phân công" | "Người hỗ trợ" | "Người bổ sung",
    string
  > = {
    "Người nhận phân công": "#16423C",
    "Người hỗ trợ": "#6A9C89",
    "Người bổ sung": "#C4DAD2",
  };

  const optionColorPriority: Record<"Cao" | "Thấp", string> = {
    Cao: "#FF0000",
    Thấp: "#808080",
  };

  const renderSelectOptionProcessingMethod: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorProcessingMethod[
            option.label as
              | "Xử lý tại nhà"
              | "Xử lý tại CH/CN"
              | "Hãng xử lý"
              | "Xử lý trực tiếp"
              | "Xử lý từ xa"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const renderSelectOptionRole: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorRole[
            option.label as
              | "Người nhận phân công"
              | "Người hỗ trợ"
              | "Người bổ sung"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const renderSelectOptionPriority: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={optionColorPriority[option.label as "Cao" | "Thấp"]}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  function modalRemoteProcessing(
    id: number | string,
    status: string | null,
    processing: string,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật thông tin bảo hành sản phẩm</Title>
        </>
      ),
      size: "auto",
      children: (
        <RemoteProcessing
          id={id}
          onClose={setDeleteViewStatus}
          status={status}
          processing={processing}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.processingMethod) {
      url += `&ProcessingMethodId=${search.processingMethod}`;
    }

    if (search.role) {
      url += `&AssignRole=${search.role}`;
    }

    if (search.priority) {
      url += `&Priority=${search.priority}`;
    }

    if (search.status) {
      url += `&RequestStatus=${search.status}`;
    }

    if (keySearch) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryMdm.get<
        MessageResponse<TblWarrantyInformation[]>
      >(`/api/v1/TblWarrantyServiceRequestForm/get-list-for-employee${url}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(response.data);
        setRowCount(result.length);
        setSelectIds([]);
        await Promise.all([getDataProcessingMethod()]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    sessionStorage.setItem(
      String(location.pathname),
      JSON.stringify({
        ...search,
        keySearch: keySearch,
      }),
    );
    startCountdown();
  };

  const getDataProcessingMethod = async () => {
    const getData = await getTblDmProcessingMethodSelect();
    setDataProcessingMethodSelect(
      getData
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (162.5 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningWarrantyInformation",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["requestFormCode", "role"],
          right: ["processingMethodName", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningWarrantyInformation",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <_breadcrumb></_breadcrumb>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <Select
              placeholder="Hình thức xử lý"
              data={dataProcessingMethodSelect}
              value={search.processingMethod || null}
              leftSection={<IconAdjustmentsCog color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "processingMethod")
              }
              renderOption={renderSelectOptionProcessingMethod}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <Select
              placeholder="Vai trò"
              data={[
                {
                  label: "Người nhận phân công",
                  value: "Người nhận phân công",
                },
                { label: "Người hỗ trợ", value: "Người hỗ trợ" },
              ]}
              value={search.role || null}
              leftSection={<IconUserShield color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "role")
              }
              renderOption={renderSelectOptionRole}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <Select
              placeholder="Độ ưu tiên"
              data={[
                { label: "Cao", value: "Cao" },
                { label: "Thấp", value: "Thấp" },
              ]}
              value={search.priority || null}
              leftSection={<IconFlame color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "priority")
              }
              renderOption={renderSelectOptionPriority}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <Select
              placeholder="Trạng thái"
              data={[
                { label: "Hủy phân công", value: "HUY_PHAN_CONG" },
                { label: "Đã phân công", value: "DA_PHAN_CONG" },
                { label: "Xử lý lại", value: "XU_LY_LAI" },
                { label: "Kỹ thuật hủy", value: "KY_THUAT_HUY" },
                { label: "Đang xử lý", value: "DANG_XU_LY" },
                { label: "Đã xử lý", value: "DA_XU_LY" },
                { label: "Trả khách", value: "TRA_KHACH" },
              ]}
              leftSection={<IconStatusChange color="#15aabf" />}
              clearable
              value={search.status || null}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "status")
              }
              renderOption={renderSelectOptionStatus}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa ..."
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value ?? "")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <Button
              variant="outline"
              color="blue"
              leftSection={<IconSearch size={14} />}
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      // pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <MantineReactTable table={table} />
    </>
  );
};

export default WarrantyInformation;
